// Scoring and achievement calculations

export interface ScoreResult {
  score: number;
  total: number;
  percentage: number;
  grade: string;
  message: string;
  emoji: string;
}

export function calculateScore(correct: number, total: number): ScoreResult {
  const percentage = Math.round((correct / total) * 100);

  let grade: string;
  let message: string;
  let emoji: string;

  if (percentage >= 90) {
    grade = 'Sehr gut';
    message = 'Unglaublich! Du bist eine Expertin!';
    emoji = '🏆';
  } else if (percentage >= 80) {
    grade = 'Gut';
    message = 'Super gemacht! Weiter so!';
    emoji = '🌟';
  } else if (percentage >= 70) {
    grade = 'Befriedigend';
    message = 'Richtig gut! Noch ein bisschen üben!';
    emoji = '👍';
  } else if (percentage >= 60) {
    grade = 'Genügend';
    message = 'Guter Anfang! Schau dir die Lektionen nochmal an!';
    emoji = '📚';
  } else if (percentage >= 50) {
    grade = 'Nicht genügend';
    message = 'Nicht aufgeben! Übung macht den Meister!';
    emoji = '💪';
  } else {
    grade = 'Nicht genügend';
    message = 'Lerne mit den Lernkarten und versuch es nochmal!';
    emoji = '🎯';
  }

  return {
    score: correct,
    total,
    percentage,
    grade,
    message,
    emoji,
  };
}

export function getStreakMessage(streak: number): { message: string; emoji: string } {
  if (streak === 0) {
    return { message: 'Starte heute deine Lernstreak!', emoji: '🚀' };
  } else if (streak === 1) {
    return { message: '1 Tag gelernt! Mach morgen weiter!', emoji: '🔥' };
  } else if (streak < 7) {
    return { message: `${streak} Tage in Folge! Weiter so!`, emoji: '🔥' };
  } else if (streak < 30) {
    return { message: `${streak} Tage Streak! Du bist unaufhaltsam!`, emoji: '🔥🔥' };
  } else {
    return { message: `${streak} Tage! Du bist eine Lernmaschine!`, emoji: '🔥🔥🔥' };
  }
}

export function calculateCourseProgress(
  completedLessons: number,
  totalLessons: number,
  flashcardsKnown: number,
  totalFlashcards: number,
  averageQuizScore: number
): number {
  // Weight: Lessons 30%, Flashcards 30%, Quiz 40%
  const lessonProgress = totalLessons > 0 ? (completedLessons / totalLessons) * 30 : 0;
  const flashcardProgress = totalFlashcards > 0 ? (flashcardsKnown / totalFlashcards) * 30 : 0;
  const quizProgress = (averageQuizScore / 100) * 40;

  return Math.round(lessonProgress + flashcardProgress + quizProgress);
}
